import React from 'react';
import { IIconProps } from '../IIconProps';

export const ModalEditIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 56 46"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M8.91797 28.9016L32.8624 4.95711L41.0442
				 13.1389L17.0998 37.0833H8.91797V28.9016Z"
				stroke="#2C3171"
			/>
			<circle cx="33.5" cy="28.5" r="11.5" fill="white" stroke="#2C3171" />
			<path d="M48.3346 16.5L32.7513 32.0833L25.668 25" stroke="#2C3171" />
		</svg>
	);
};
